import React from "react";
import "./Loader.scss";

// Loader is already optimized as a static SVG and React.memo
const Loader = React.memo(({ fullScreen }) => {
  return (
    <div className={`loader-wrapper ${fullScreen ? "fullscreen" : ""}`}>
      <div className="loader-container">
        <div className="loader">
          {/* Inline SVG for instant rendering */}
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            className="loader-svg"
            aria-label="Loading"
          >
            <circle
              cx="32"
              cy="32"
              r="28"
              stroke="#5A1740"
              strokeWidth="6"
              fill="none"
              opacity="0.2"
            />
            <circle
              cx="32"
              cy="32"
              r="28"
              stroke="#5A1740"
              strokeWidth="6"
              fill="none"
              strokeDasharray="44 200"
              strokeLinecap="round"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 32 32"
                to="360 32 32"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
});
Loader.displayName = "Loader";

export default Loader;
